import type { Icon } from "iconsax-react";

interface ProfileDataRowProps {
  icon: Icon;
  label: string;
  value: string | null | undefined;
}

export default function ProfileDataRow({ icon: Icon, label, value }: ProfileDataRowProps) {
  if (value == null || value === "") return null;
  return (
    <div className="flex justify-between items-center gap-2 py-4 first:pt-0 last:pb-0 not-last:border-b surface-component-stroke ">
      <div className="flex justify-start align-center gap-2">
        <div className="w-5 aspect-square flex shrink-0 justify-center items-center content-action-brand">
          <Icon size={18} color="currentColor" />
        </div>
        <span className="text-body-regular-md content-base-secondary">{label}</span>
      </div>
      <span className="text-body-bold-md content-base-primary">{value}</span>
    </div>
  );
}

